<template>
<b-container fluid class="container">
   <b-row class="justify-content-md-center">
          <b-col col md="3" class="text-center">
           <Descripcion/>
            <div class="mb-5" >
                  <img src="../assets/wizard5.png" class="img-fluid" alt="" />
            </div>
            <hr>
            <div class="mb-5">
              <h6>Estamos para ayudarte</h6>
              <p style="font-size: 15px">¿Deseas ser asistido por uno de nuestros asesores?</p>
                  <b-button @click.prevent="" variant="outline-primary" class="button_H11">Estamos para ayudarte</b-button>
            </div>
          </b-col>
          <b-col  col md="9" class="card-body text-center">
            <Sesion/>
            <h1 class="mt-5">Ingresa tu código de verificación</h1>
            <p>Recibiste un número de 6 dígitos por SMS o email</p>

  <b-row align-h="center" class="justify-content-md-center m-auto">
    <b-col md="6" lg="6" sm="6" class="p-4 rounded">
      <b-alert v-model="errorService" variant="danger" >Error Service</b-alert>
      <b-alert v-model="error" class="mensajev" variant="danger" >{{this.merror}}</b-alert>
      <!-- <b-alert v-model="caduca" class="mensajev" variant="info" >Tu Código ha caducado</b-alert> -->
      <!-- <b-alert :show="dismissCountDown" class="mensajev" fade variant="success" @dismiss-count-down="countDownChanged">
        El código vence en {{ dismissCountDown }} segundos
      </b-alert> -->
      <b-form v-if="show">
            <!-- <pre class="m-0">{{ this.memoria }}</pre> -->
             <b-row>
               <b-col cols="2">
                    <b-form-group id="input-group-1" class="text-left" label-for="input-1">
                    <b-form-input id="input-1" class="boderCod input" v-model="form.uno" type="text" placeholder="" maxlength="1" onkeyup="javascript:if(this.value.length >= 1) {document.getElementById('input-2').focus(); return false;}" onkeypress="return (event.charCode == 8 || event.charCode == 0 || event.charCode == 13) ? null : event.charCode >= 48 && event.charCode <= 57" required autofocus></b-form-input>
                    </b-form-group>                
                </b-col>
                <b-col cols="2">
                    <b-form-group id="input-group-2" class="text-left" label-for="input-2">
                    <b-form-input id="input-2" class="boderCod input" v-model="form.dos" type="text" placeholder="" maxlength="1" onkeyup="javascript:if(this.value.length >= 1) {document.getElementById('input-3').focus(); return false;}" onkeypress="return (event.charCode == 8 || event.charCode == 0 || event.charCode == 13) ? null : event.charCode >= 48 && event.charCode <= 57" required></b-form-input>
                    </b-form-group>        
                </b-col>

                <b-col cols="2">
                    <b-form-group id="input-group-3" class="text-left" label-for="input-3">
                    <b-form-input id="input-3" class="boderCod input" v-model="form.tres" type="text" placeholder="" maxlength="1" onkeyup="javascript:if(this.value.length >= 1) {document.getElementById('input-4').focus(); return false;}" onkeypress="return (event.charCode == 8 || event.charCode == 0 || event.charCode == 13) ? null : event.charCode >= 48 && event.charCode <= 57" required></b-form-input>
                    </b-form-group>        
                </b-col>
                <b-col cols="2">
                    <b-form-group id="input-group-4" class="text-left" label-for="input-4">
                    <b-form-input id="input-4" class="boderCod input" v-model="form.cuatro" type="text" placeholder="" maxlength="1" onkeyup="javascript:if(this.value.length >= 1) {document.getElementById('input-5').focus(); return false;}" onkeypress="return (event.charCode == 8 || event.charCode == 0 || event.charCode == 13) ? null : event.charCode >= 48 && event.charCode <= 57" required></b-form-input>
                    </b-form-group>                
                </b-col>
                <b-col cols="2">
                    <b-form-group id="input-group-5" class="text-left" label-for="input-5">
                    <b-form-input id="input-5" class="boderCod input" v-model="form.cinco" type="text" placeholder="" maxlength="1" onkeyup="javascript:if(this.value.length >= 1) {document.getElementById('input-6').focus(); return false;}" onkeypress="return (event.charCode == 8 || event.charCode == 0 || event.charCode == 13) ? null : event.charCode >= 48 && event.charCode <= 57" required></b-form-input>
                    </b-form-group>        
                </b-col>
                <b-col cols="2">
                    <b-form-group id="input-group-6" class="text-left" label-for="input-6">
                    <b-form-input id="input-6" class="boderCod input" v-model="form.seis" type="text" placeholder="" maxlength="1" onkeypress="return (event.charCode == 8 || event.charCode == 0 || event.charCode == 13) ? null : event.charCode >= 48 && event.charCode <= 57" required></b-form-input>
                    </b-form-group>        
                </b-col>
            </b-row>
      <div class="mt-3"><b-button @click.prevent="confirmar()" class="button_H">CONFIRMAR</b-button></div>
      <!-- <div class="mt-3"><b-button @click.prevent="regresar()" variant="primary" class="button_H">GENERAR OTRO CÓDIGO</b-button></div> -->
      <div class="mt-3"><b-button @click.prevent="" class="button_H">REENVIAR CÓDIGO</b-button></div>
    </b-form>
    <!-- <b-card class="mt-3" header="Form Data Result">
      <pre class="m-0">{{ form }}</pre>
    </b-card> -->


    </b-col>
    </b-row>
    </b-col>
    </b-row>
</b-container>
</template>

<script>
import Sesion from './Sesion.vue';
import Descripcion from './Descripcion.vue';

export default {
  name: 'Codigo',

  components: {
    Sesion,
    Descripcion
  },

    data() {
    return {
      nombre: sessionStorage.getItem("nombre"),
      paterno: sessionStorage.getItem("paterno"),
      materno: sessionStorage.getItem("materno"),
      telefono: sessionStorage.getItem("telefono"),
      mail:sessionStorage.getItem("mail"),
      monto: sessionStorage.getItem("montoWeb"),
      memoria: sessionStorage.getItem("codigoReserva"),
      merror: '',
      contents: null,
      autos: [],
      photos: '',
      form: {
          uno: '',
          dos: '',
          tres: '',
          cuatro: '',
          cinco: '',
          seis: '',
        },
        show: true,
        error: false,
        errorService: false,
        caduca: false,
        dismissSecs: 60,
        dismissCountDown: 0
      };
  },

  methods: {

      countDownChanged(dismissCountDown) {
        this.dismissCountDown = dismissCountDown
        if( this.dismissCountDown == 0 ){
          this.onReset();
          sessionStorage.removeItem('codigoReserva');
          sessionStorage.setItem("codigoReserva", 'No Number');
          this.memoria = sessionStorage.getItem("codigoReserva");
          this.caduca=true;
          this.error=false;
        }
      },

      showAlert() {
        this.dismissCountDown = this.dismissSecs
      },

        onSubmit(event) {
            event.preventDefault();
        },

        onReset(event) {
            window.history.go(-2);
        },

        regresar(){
            window.history.go(-1);
        },

      confirmar(){
        this.codigoReserva= this.form.uno+this.form.dos+this.form.tres+this.form.cuatro+this.form.cinco+this.form.seis;
        if (this.codigoReserva != ''){
            let user = {
                customerName: this.nombre,
                customerSurname: this.paterno,
                customerSurname2: this.materno,
                customerEmail: this.mail,
                customerPhone: this.telefono,
                app: 'Reservas',
            }

          axios.put('https://qasrv-login.autocom.mx/api/Customer/ConfirmCustomer/'+this.codigoReserva, user,  {
            headers: {
            Authorization: "Bearer " + sessionStorage.getItem("tknUser"),
            'Content-Type': 'application/json',
            }, 
            }).then(response =>{
              this.acceso = response.data.status;
              if (this.acceso == 'success'){
                  this.$router.push({ path: '/Bienvenida'});
                  sessionStorage.removeItem("nombre");
                  sessionStorage.removeItem("paterno");
                  sessionStorage.removeItem("materno");
                  sessionStorage.removeItem("telefono");
                  sessionStorage.removeItem("mail");
                  sessionStorage.removeItem("loginAct");
              } else {
                this.error=true;
                this.onReset();
                this.merror = response.data.message;
                console.log('Error--> ',this.merror);
              }
            }).catch(error=>{
                this.errorService = true;
                console.log(error)
            });
        }
        else {
          this.error=true;
          this.onReset();
          this.merror = 'Se debe Ingresar un código';
        }

      },

      // enviar(){
      //   this.codigoReserva= this.form.uno+this.form.dos+this.form.tres+this.form.cuatro+this.form.cinco+this.form.seis;
      //   this.caduca=false;
      //   if(this.codigoReserva == this.memoria){
      //       this.llave = this.codigoReserva+'-'+sessionStorage.getItem("idClient");
      //       this.session= true;
      //       sessionStorage.setItem("session", this.session);
      //       this.$router.push({ path: '/Bienvenida'});
      //   } else {
      //     this.error=true;
      //     this.onReset();
      //   }
      // },

      // generaCodigo() {
      //   sessionStorage.removeItem('codigoReserva');
      //   this.codigoReserva = Math.floor(100000 + Math.random() * 900000);
      //   sessionStorage.setItem("codigoReserva", this.codigoReserva);
      //   this.memoria = sessionStorage.getItem("codigoReserva");
      //   this.onReset();
      //   this.showAlert();
      //   this.caduca=false;
      //   this.error=false;
      //   return this.codigoReserva;
      // },

      onReset() {
        this.form.uno = ''
        this.form.dos = ''
        this.form.tres = ''
        this.form.cuatro = ''
        this.form.cinco = ''
        this.form.seis = ''
        // this.show = false
        // this.$nextTick(() => {
        // this.show = true
        // })
      },

    formatPrice(value) {
        let val = (value/1).toFixed(0).replace('.', '.')
        return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
    },

    formatPriceCostos(value) {
        let val = (value/1).toFixed(2).replace('.', '.')
        return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
    },
  },
  
  created() {
      //this.showAlert();
  },

}
</script>

<style scoped>


</style>